import { styled } from '@mui/material/styles';

export const ResultsPageContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: 16,

    backgroundColor: (theme.vars || theme).palette.background.default, //to hide the container of pdf generation
}));
